import { render, staticRenderFns } from "./ClicMarkdown.vue?vue&type=template&id=098f351e&scoped=true&"
import script from "./ClicMarkdown.vue?vue&type=script&lang=js&"
export * from "./ClicMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./ClicMarkdown.vue?vue&type=style&index=0&id=098f351e&lang=scss&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f351e",
  null
  
)

export default component.exports